@if (sharepointExportResponse$ | async; as sharepointExportResponse) {
  @if (sharepointExportResponse.isSuccess) {
    <app-construction-documents-wrapper>
      <div class="page-wrapper">
        <div class="top-container">
          <div class="left-container">
            <gc-button
              [variant]="'plain'"
              [icon]="'arrowLeft'"
              (clicked)="handleOnClickBack()"
            />
            <gc-text [variant]="'smallHeading'">{{
              'sharepointExport.sharepointExport' | translate
            }}</gc-text>
          </div>
          <div class="right-container">
            <gc-button
              [isLoading]="isRefreshingHcConstructionReports()"
              [disabled]="isRefreshingHcConstructionReports()"
              (clicked)="handleOnClickRefreshHcConstructionReports()"
            >
              {{ 'sharepointExport.refreshHcs' | translate }}
            </gc-button>
            <gc-button
              (clicked)="
                handleOnClickExportAllReady(sharepointExportResponse.data)
              "
            >
              {{ 'sharepointExport.exportAllReady' | translate }}
            </gc-button>
            <gc-button
              [variant]="'secondary'"
              [icon]="'circularArrows'"
              [iconPosition]="'right'"
              [iconSize]="'medium'"
              [isLoading]="sharepointExportResponse.isLoading"
              (clicked)="handleOnClickRefresh()"
            >
              {{ 'sharepointExport.refresh' | translate }}
            </gc-button>
          </div>
        </div>
        <div class="help-button-wrapper">
          <gc-button
            [variant]="'utility'"
            [size]="'small'"
            [icon]="'circleQuestion'"
            (clicked)="openHelpModal()"
            >{{ 'sharepointExport.help' | translate }}</gc-button
          >
        </div>
        @if (isLoadingConstructionReports()) {
          <div class="gc-table-skeleton">
            <gc-skeleton [height]="'100%'" />
          </div>
        } @else {
          <gc-table
            [tableColumns]="tableColumns()"
            [tableRows]="
              sharepointExportResponse?.data ?? null | tableRowsSharepointExport
            "
            [cellTemplates]="{
              status: statusTemplate,
              failed: failedTemplate,
              exportButton: exportButtonTemplate,
            }"
          />
        }
      </div>
    </app-construction-documents-wrapper>
  } @else {
    <div class="error-page">
      <app-error-information
        [iconName]="'smileySad'"
        [iconColor]="'critical'"
        [errorString]="'sharepointExport.error'"
      />
    </div>
  }

  <ng-template #statusTemplate let-status>
    <gc-text [textColor]="status.textColor">{{ status.copy }}</gc-text>
  </ng-template>

  <ng-template #failedTemplate let-failed>
    <gc-text [textColor]="'critical-strong'">{{ failed }}</gc-text>
  </ng-template>

  <ng-template #exportButtonTemplate let-exportButton>
    <gc-button
      [variant]="exportButton.styling.type"
      [disabled]="exportButton.styling.disabled"
      [isLoading]="loadingExportReportTypes().includes(exportButton.reportType)"
      (clicked)="
        handleOnClickExport(
          exportButton.reportType,
          sharepointExportResponse.data
        )
      "
    >
      {{ exportButton.copy }}
    </gc-button>
  </ng-template>
} @else {
  <div class="loading-page">
    <div class="loading-content">
      <gc-loading-spinner />
      <gc-text [variant]="'subHeading'">{{
        'sharepointExport.loading.pleaseWait' | translate
      }}</gc-text>
    </div>
  </div>
}

@if (isOverwriteReportsModalOpen()) {
  <app-overwrite-reports-confimation-modal
    (confirm)="confirmOverwriteReports()"
    (cancel)="cancelOverwriteReports()"
  />
}

@if (isHelpModalOpen()) {
  <app-help-modal />
}

<app-feedback-alert />
